module.exports = __webpack_public_path__ + "static/CLIENT SERVICE AGREEMENT-53f894375ca3d6cd8deb895317ab2e7b.pdf";